import { Calendar, Clock } from 'lucide-react';
import type { Fixture } from '../../services/footballApi';
import { formatMatchDate, formatMatchTime } from '../../services/footballApi';

interface MatchCardProps {
  fixture: Fixture;
  showLeague?: boolean;
}

export function MatchCard({ fixture, showLeague = true }: MatchCardProps) {
  const isFinished = fixture.fixture.status.short === 'FT';
  const isLive = fixture.fixture.status.short === 'LIVE';

  return (
    <div className="bg-gray-50 rounded-lg p-4">
      {showLeague && (
        <div className="text-sm text-gray-600 mb-2">{fixture.league.name}</div>
      )}
      
      <div className="flex justify-between items-center mb-2">
        <div className="flex items-center gap-3">
          <span className="font-semibold">{fixture.teams.home.name}</span>
        </div>
        {isFinished ? (
          <span className="text-lg font-bold">{fixture.goals.home}</span>
        ) : null}
      </div>
      
      <div className="flex justify-between items-center mb-3">
        <div className="flex items-center gap-3">
          <span className="font-semibold">{fixture.teams.away.name}</span>
        </div>
        {isFinished ? (
          <span className="text-lg font-bold">{fixture.goals.away}</span>
        ) : null}
      </div>

      <div className="flex justify-between items-center text-sm text-gray-600">
        <div className="flex items-center gap-3">
          <div className="flex items-center gap-1">
            <Calendar className="w-4 h-4" />
            <span>{formatMatchDate(fixture.fixture.date)}</span>
          </div>
          <div className="flex items-center gap-1">
            <Clock className="w-4 h-4" />
            <span>{formatMatchTime(fixture.fixture.date)}</span>
          </div>
        </div>
        {isLive && (
          <span className="px-2 py-1 bg-red-100 text-red-800 rounded-full text-xs font-semibold">
            LIVE
          </span>
        )}
      </div>
    </div>
  );
}